export const CANDIDATE_PATH = "/candidates/:id";
